import { render, staticRenderFns } from "./Sets.vue?vue&type=template&id=79aaa6d2&scoped=true&"
import script from "./Sets.vue?vue&type=script&lang=js&"
export * from "./Sets.vue?vue&type=script&lang=js&"
import style0 from "./Sets.vue?vue&type=style&index=0&id=79aaa6d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79aaa6d2",
  null
  
)

export default component.exports